import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading3XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

const SECTION_LABEL = "Why Verse Medical";
const SECTION_DESCRIPTION =
  "Deliver administrative efficiency, meaningful savings, and a superior DME experience for members and clinicians.";
const BUTTON_TEXT = "Learn more";

export const WhyVerseSection = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[4em] tw-rounded-[4em] tw-bg-[#000862] tw-bg-[url('/landing_page_assets/backgrounds/bg3.jpg')] tw-bg-cover tw-bg-bottom tw-py-[5em] min840:tw-py-[7.5em]">
      <div className="tw-flex tw-w-full tw-max-w-[1448px] tw-items-center tw-justify-center tw-gap-x-[1em] min1040:tw-px-[4.75em]">
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-x-[4em] tw-gap-y-[1.5em] tw-px-[1.5em] min1040:tw-flex-row">
          <img
            src="/landing_page_assets/payor_network_page/why-verse.jpg"
            alt="Why Verse Medical"
            className="tw-h-full tw-w-full tw-rounded-[32px] tw-object-contain min1040:tw-w-1/2"
          />
          <div className="tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-[1.5em] min1040:tw-w-1/2">
            <div className="tw-flex tw-flex-col tw-gap-[1.5em]">
              <BodyXL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                {SECTION_LABEL}
              </BodyXL>
              <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
                {SECTION_LABEL}
              </BodyLG>
              <Heading3XL className="tw-my-0 tw-hidden tw-text-white min440:tw-flex">
                {SECTION_DESCRIPTION}
              </Heading3XL>
              <Heading2XL className="tw-my-0 tw-text-white min440:tw-hidden">
                {SECTION_DESCRIPTION}
              </Heading2XL>
            </div>
            <StandardButton
              onClick={() => {}}
              style={"primary-blue"}
              className="tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
            >
              <Link to="/contact" className="tw-no-underline">
                <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                  {BUTTON_TEXT}
                </BodyLGB>
                <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                  {BUTTON_TEXT}
                </BodyMDB>
              </Link>
            </StandardButton>
          </div>
        </div>
      </div>
    </div>
  );
};
